module.exports = __webpack_public_path__ + "static/media/csa.2c90efa6.svg";